export const setValueToNone = obj => {
  const newObj = { ...obj };

  for (const key in newObj) {
    if (newObj[key] === "null" || newObj[key] === "") {
      newObj[key] = "N/A";
    }
  }

  return newObj;
};
